/**
 * Ultima route di ogni host: un percorso che non è stato servito dai prodotti montati qui.
 * - appartiene a un altro prodotto con un suo dominio → ci si va, conservando percorso e parametri;
 * - altrimenti (Console da un dominio di prodotto, app nativa, percorso inesistente) → 404.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import { placePath } from "./hosts";
import { platform } from "./runtime";

export function ProductBoundary() {
  const location = useLocation();
  const placement = placePath(location, platform.resolution, platform.env, platform.localPort);

  const redirectUrl = placement.kind === "redirect" ? placement.url : null;
  useEffect(() => {
    if (redirectUrl) window.location.replace(redirectUrl);
  }, [redirectUrl]);

  if (redirectUrl) return null;
  return <NotFound />;
}
